import { render } from "./ChangePasswordIcon.vue?vue&type=template&id=67776a36"
import script from "./ChangePasswordIcon.vue?vue&type=script&lang=js"
export * from "./ChangePasswordIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__